let toastr=require('toastr/build/toastr.min');
import 'toastr/build/toastr.css';
import './ToastService.css';

export  class ToastService{
    public static SetOptions(options:any)
    {
        toastr.options=Object.assign(toastr.options,options);
    }

    public static SendErrorMessage(message:string){
        toastr["error"](message);
    }

    public static SendSuccess(message:string){
        toastr["success"](message);
    }

    static SendWarning(message: string) {
        toastr["warning"](message);
    }
}

ToastService.SetOptions({positionClass: "toast-top-center"});